function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as P, Fragment as tt, jsx as w } from "react/jsx-runtime";
import * as o from "react";
import E from "classnames";
import { CSSTransition as et } from "react-transition-group";
import { useTheme as rt, useScreenSize as nt, useAriaId as ot } from "./hooks.js";
import { Portal as it } from "./portal.js";
import at from "./overlay.js";
import { Text2 as I } from "./text.js";
import { TAB as ct } from "./utils/key-codes.js";
import st from "./stack.js";
import { vars as s, wrapper as ut, enter as lt, enterActive as dt, enterDone as ft, exit as ht, exitActive as wt, container as mt, textAlign as pt, arrowWrapper as gt, arrow as xt, fadeInTopKeyframes as Tt, fadeInBottomKeyframes as vt, fadeInXKeyframes as bt, arrowTop as At, arrowBottom as Pt, arrowLeft as St, arrowRight as Yt } from "./tooltip.css-mistica.js";
import { assignInlineVars as Ot } from "@vanilla-extract/dynamic";
import { getPrefixedDataAttributes as Rt } from "./utils/dom.js";
import { isClientSide as yt, isServerSide as Ct } from "./utils/environment.js";
const Dt = "bottom", Wt = "top", $t = 12, m = 4 + $t, Bt = 500, v = 12, Et = 500, M = ()=>{}, It = (r)=>r === "bottom" ? `translateY(${v}px)` : r === "top" ? `translateY(calc(-100% - ${v}px))` : r === "right" ? `translateX(${v}px) translateY(-50%)` : r === "left" ? `translateX(-${v}px) translateY(-50%)` : `translateY(-${v}px)`, Mt = (r)=>r === "top" ? "translateY(-100%)" : r === "bottom" ? "translateY(0)" : "translateY(-50%)", Nt = (r)=>r === "bottom" ? "translateY(0)" : r === "top" ? "translateY(-100%)" : r === "right" || r === "left" ? "translateX(0px) translateY(-50%)" : "translateY(0px)", kt = (r)=>r === "top" ? Tt : r === "bottom" ? vt : bt, Lt = (r)=>r ? "1" : "0.2", Vt = (r)=>r === "top" ? `2px 2px 4px 0 rgba(0, 0, 0, ${s.shadowAlpha})` : r === "right" ? `0 0 4px 0 rgba(0, 0, 0, ${s.shadowAlpha})` : r === "left" ? `0 0 4px 0 rgba(0, 0, 0, ${s.shadowAlpha})` : r === "bottom" ? `-1px -1px 4px 0 rgba(0, 0, 0, ${s.shadowAlpha})` : "", jt = (_param)=>{
    var { children: r , extra: N , description: S , target: k , title: Y , targetLabel: L , delay: V = !0 , dataAttributes: j , targetStyle: K , unstable_offsetX: f  } = _param, C = _object_without_properties(_param, [
        "children",
        "extra",
        "description",
        "target",
        "title",
        "targetLabel",
        "delay",
        "dataAttributes",
        "targetStyle",
        "unstable_offsetX"
    ]);
    const { isDarkMode: z  } = rt(), [a, O] = o.useState(!1), { isTabletOrSmaller: F  } = nt(), D = ot(), h = o.useRef(!1), c = o.useRef(null), g = o.useRef(null), R = o.useRef(null), x = o.useRef(null), t = o.useRef({
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        width: 0,
        height: 0
    }), [H, X] = o.useState({}), q = (n)=>F ? n || Wt : n || Dt, [e, G] = o.useState(void 0), i = ((n)=>{
        if (!e) return n;
        const u = (d)=>{
            const p = t.current.top > e.height;
            return t.current.left < e.width ? p ? "top" : "bottom" : d;
        }, l = (d)=>t.current.right + e.width > window.innerWidth ? u("left") : d;
        return ({
            top: t.current.top < e.height ? l("bottom") : l(n),
            right: l(n),
            left: t.current.left < e.width ? t.current.right + e.width > window.innerWidth ? t.current.top < e.height ? "bottom" : "top" : "right" : n,
            bottom: t.current.bottom + e.height > window.innerHeight ? l("top") : l(n)
        })[n];
    })(q(C.position)), y = yt() ? window.matchMedia("(pointer: coarse)").matches : !1, W = ()=>{
        a && O(!1);
    };
    o.useEffect(()=>(window.addEventListener("resize", W), ()=>{
            window.removeEventListener("resize", W);
        }));
    const $ = ()=>{
        O(!1);
    }, T = ()=>{
        R.current && (t.current = R.current.getBoundingClientRect(), O(!a));
    }, J = ()=>{
        a || T();
    }, Q = (n)=>{
        n.keyCode === ct && $();
    }, U = (n)=>{
        if (!e) return {};
        const u = e.width > t.current.width && t.current.left + t.current.width / 2 < e.width / 2 + 16 ? t.current.width / 2 : "50%";
        return n === "bottom" || n === "top" ? {
            left: u
        } : {};
    }, B = o.useCallback((n, u)=>{
        if (Ct() || !e) return {};
        const l = e.width > t.current.width && t.current.left + t.current.width / 2 < e.width / 2 + 16 ? Math.round(e.width / 2 - t.current.width / 2) : 0, A = f || (u ? window.pageXOffset + t.current.left + t.current.width / 2 - u / 2 : window.pageXOffset + t.current.left + l + t.current.width / 2 - e.width / 2), d = t.current.left < e.width ? A : u ? t.current.left - u - m : t.current.left - e.width - m, p = t.current.left < e.width ? t.current.top < e.height ? window.pageYOffset + t.current.bottom + m : window.pageYOffset + t.current.top - m : f || window.pageYOffset + t.current.top + t.current.height / 2;
        return ({
            right: {
                left: t.current.right + e.width > window.innerWidth ? d : t.current.right + m,
                top: t.current.right + e.width > window.innerWidth ? p : f || window.pageYOffset + t.current.top + t.current.height / 2
            },
            left: {
                left: d,
                top: p
            },
            top: {
                top: t.current.right + e.width > window.innerWidth ? p : window.pageYOffset + t.current.top - m,
                left: t.current.right + e.width > window.innerWidth ? d : A
            },
            bottom: {
                top: t.current.right + e.width > window.innerWidth ? p : window.pageYOffset + t.current.bottom + m,
                left: t.current.right + e.width > window.innerWidth ? d : A
            }
        })[n];
    }, [
        f,
        e
    ]), b = (()=>C.width)(), Z = {
        top: At,
        bottom: Pt,
        left: St,
        right: Yt
    }, _ = i && Ot({
        [s.enterTransform]: It(i),
        [s.exitTransform]: Nt(i),
        [s.enterActiveAnimationName]: kt(i),
        [s.enterDoneTransform]: Mt(i),
        [s.shadowAlpha]: Lt(z),
        [s.arrowBoxShadow]: Vt(i)
    });
    return o.useEffect(()=>{
        i && x.current && a && X(B(i, b || 0));
    }, [
        a,
        B,
        i,
        b
    ]), o.useEffect(()=>{
        x.current && (x.current.getBoundingClientRect(), a && G(x.current.getBoundingClientRect()));
    }, [
        a
    ]), /* @__PURE__ */ P(tt, {
        children: [
            /* @__PURE__ */ w("div", {
                ref: R,
                style: K,
                className: ut,
                onPointerOver: ()=>{
                    c.current && (clearTimeout(c.current), c.current = null), !h.current && (h.current = !0, V ? g.current = setTimeout(()=>{
                        g.current = null, T();
                    }, Et) : T());
                },
                onPointerLeave: y ? M : ()=>{
                    if (g.current) {
                        clearTimeout(g.current), g.current = null, h.current = !1;
                        return;
                    }
                    c.current = setTimeout(()=>{
                        h.current && (c.current = null, h.current = !1, T());
                    }, 100);
                },
                onFocus: J,
                onKeyDown: Q,
                "touch-action": "auto",
                role: "button",
                tabIndex: 0,
                "aria-describedby": D,
                "aria-expanded": a,
                "aria-label": L,
                children: k
            }),
            /* @__PURE__ */ P(it, {
                children: [
                    a && y && /* @__PURE__ */ w(at, {
                        onPress: $
                    }),
                    /* @__PURE__ */ w(et, {
                        in: a,
                        timeout: Bt,
                        classNames: {
                            enter: lt,
                            enterActive: dt,
                            enterDone: ft,
                            exit: ht,
                            exitActive: wt
                        },
                        unmountOnExit: !0,
                        children: /* @__PURE__ */ P("div", _object_spread_props(_object_spread({
                            ref: x
                        }, Rt(j, "Tooltip")), {
                            role: "tooltip",
                            id: D,
                            className: E(mt, pt),
                            style: _object_spread({
                                width: b
                            }, H, _),
                            onPointerOver: ()=>{
                                c.current && (clearTimeout(c.current), c.current = null);
                            },
                            onPointerLeave: y ? M : ()=>{
                                c.current = setTimeout(()=>{
                                    h.current && (c.current = null, h.current = !1, T());
                                }, 100);
                            },
                            children: [
                                /* @__PURE__ */ w("div", {
                                    style: U(i),
                                    className: E(gt, Z[i]),
                                    children: /* @__PURE__ */ w("div", {
                                        className: xt
                                    })
                                }),
                                (Y || S) && /* @__PURE__ */ P(st, {
                                    space: 4,
                                    children: [
                                        Y && /* @__PURE__ */ w(I, {
                                            medium: !0,
                                            children: Y
                                        }),
                                        S && /* @__PURE__ */ w(I, {
                                            regular: !0,
                                            children: S
                                        })
                                    ]
                                }),
                                N || r
                            ]
                        }))
                    })
                ]
            })
        ]
    });
}, oe = jt;
export { oe as default };
